























































































































































































































































































































































































































































































































































































































































































































































import {BasketEntity} from "@/entity/BasketEntity";
import {CargoEntity} from "@/entity/CargoEntity";
import {PaymentTypeEntity} from "@/entity/PaymentTypeEntity";
import {UsersEntity} from "@/entity/UsersEntity";
import {ProductProperties} from "@/entity/ProductEntity";
import {order} from "@/entity/OrderEntity";
import {adres} from "@/entity/AdresEntity";
import {city} from "@/entity/CityEntity";
import {district} from "@/entity/DistrictEntity";
import {CargoApiOrderEntity} from "@/entity/CargoApiOrderEntity";
import {CargoApiEntity} from "@/entity/CargoApiEntity";

import {Component, Mixins, Watch} from "vue-property-decorator";
import SsoSatisKimlikMixin from "@/mixins/SsoSatisKimlikMixin";
import SsoCakismaDialog from "@/components/SsoCakismaDialog.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import TextField from "@/components/inputs/TextField.vue";
import Number from "@/components/inputs/Number.vue";
import ImageShow from "@/components/ImageShow.vue";
import SeoText from "@/components/inputs/SeoText.vue";
import Select35 from "@/components/inputs/Select35.vue";
import LetEditable from "@/components/LetEditable.vue";
import axios, {AxiosError, AxiosResponse} from "axios";
import DownloadAllBasketButton from "@/components/DownloadAllBasketButton.vue";
import {PriceTypeEnum} from "@/entity/PriceTypeEnum";
import {data} from "jquery";
import {config} from "@/views/SiteAyarlari/SiteConfig.vue";
import Email from "@/components/inputs/Email.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import Dates from "@/components/inputs/dates.vue";
import {JobType} from "@/enum/JobType";
import {OrderStatusEntity} from "@/entity/OrderStatusEntity";
import SearchFields from "@/entity/SearchEntity";
import {integer} from "vuelidate/lib/validators";
import {resolveLicenseDuration} from "@/utils/orderLicenseDuration";


class Tenant {
  first_name: string = "";
  last_name: string = "";
  email: string = "";
  office_name: string = "";
  sso_id: any = null;
  lisans_suresi: number = 0;
  lisans_sure_birimi: string = "ay";
  is_demo: boolean = false;
  eicrapro_mail:  string = "";
  product: any = null;
  product_id: number = 0;
  package: any = null;
  package_id: number = 0;
  eicrapro_tc:string="";
  person_type:string="";
  // satis_id: number = 0;
}


class Job {
  type_id: JobType = JobType.CreateTenant;
  status: string = "WAITING";
  satis_id: number = 0;
  args: any = {};
  eicraproBitisTarihi: string = "";
  icraproWebBitisTarihi: string = "";
}

@Component({
  components: {
    Dates, Email, DownloadAllBasketButton, Select35, SeoText, ImageShow, LetEditable, Number, TextField, Id, EForm, SsoCakismaDialog
  }
})


// DEV-3174: SSO kimlik zinciri (ssoKayit, çakışma modalı, CRM geri yazma)
// CreateBasket ile ortak SsoSatisKimlikMixin'den gelir. Bu ekrandan tamamlanan
// satışta SSO hesabı açılmıyordu (TDT-3447 canlıda bu yoldan yaşandı).
export default class OrderEdit extends Mixins(SsoSatisKimlikMixin) {
  dialog: boolean = false;
  order: order = new order();
  adres: adres = new adres();
  cargoApiOrder: CargoApiOrderEntity | null = null;
  cargoApi: CargoApiEntity | null = null;
  paymentTypes: PaymentTypeEntity[] = [];
  cargo: CargoEntity = new CargoEntity();
  user: UsersEntity = new UsersEntity();
  basket: BasketEntity[] = [];
  productProperties: ProductProperties[] = [];
  cities: city[] = [];
  districts: district[] = [];
  selectedBasket: BasketEntity = new BasketEntity();
  spinner: boolean = false;
  faturaSpinner: boolean = false;
  action: string = ActionsEnum.Orders;
  title: string = "";
  kupon: string = "";
  eslesme: boolean = false;
  dealers: [] = [];
  isYeniKullanici: boolean = false;
  
  // hasData check mechanism
  hasDataCheckInterval: any = null;
  processingStatus = {
    hasData: false,
    count: 0,
    isChecking: false,
    showProgress: false,
    networkError: false,
    errorCount: 0,
    checksCount: 0, // Add check counter
    maxChecks: 30, // Stop after 30 checks (1 minute)
    isComplete: false // Add completion state
  };
  menu = false;
  modal = false;
  isAuthCreateOldDate: boolean = false;

  new_sso_user_id: number = 0;

  // --- DEV-3174: satış onay ekranı + SSO kimlik kapısı durumu ---
  // (SSO eşleştirme/çakışma durumu SsoSatisKimlikMixin'de.)
  satisOnayDialog: boolean = false;
  onayDalKodu: string | null = null;     // ön kontrole göre beklenen dal (K1..K6)
  onayKilitNedenleri: string[] = [];     // kırmızı: onay butonunu kilitleyen sorunlar
  onayHazirlaniyor: boolean = false;
  // Onay ekranında gösterilen, satışa esas kimlik (adres + CRM'den çözülür).
  onayKisi: any = {kurumMu: false, ad: "", kimlikNo: "", eposta: ""};
  // Durum 7'ye çekilirken Select35 değeri ÖNCE sunucuya yazar; SSO zinciri
  // başarısız olursa durumun geri alınacağı son bilinen değer burada tutulur.
  sonKayitliStatus: number | null = null;
  bekleyenIslem: "tenant" | "crm" | null = null;


  loading= false
  successMessage= ""
  colorMessage= ""

  showSuccessDialog: boolean = false;
  isLoading: boolean = false;

  dealer: any = {};
  seciliPersonel: [] = [];
  crmSendData: any = {};
  urunTabloData: any = [];
  urunTabloToplamData: any = [];
  orderHash: any = {
    url: "",
    phone: "",
    email: ""
  };
  kisiler: Array<any> = [];

  crmKisiResponse: boolean = false;

  lisansKisi: any = {
    ad: null,
    soyad: null,
    tc_no: null,
    acik_adres: null,
    city_id: null,
    district_id: null,
    email: null,
    phone: null,
    isKurumsal: false,
    sirketAdi: null,
    vergi_no: null,
    vergi_dairesi: null,
    fatura_il: null,
    fatura_ilce: null,
    fatura_acik_adres: null,
    telefon_turu: null

  }


  headers = [
    {text: 'Ad', value: 'Ad', sortable: false},
    {text: 'Soyad', value: 'Soyadi', sortable: false},
    {text: 'C.Telefonlar', value: 'cepTel', sortable: false},
    {text: 'S.Telefonlar', value: 'sabitTel', sortable: false},
    {text: 'Eposta', value: 'Eposta'},
    {text: 'İşlemler', value: 'actions', sortable: false},
  ];

  async get() {
    if (this.$route.params.order_id == "ekle") {
      this.order = new order();
    } else {
      this.urunTabloData = [];
      let response = await this.$http.get(this.action + "/" + this.$route.params.order_id);
      this.order = response.data.order;
      this.adres = response.data.adres;
      this.basket = response.data.basket;
      this.user = response.data.user;
      // DEV-3174: SSO zinciri başarısız olursa durumun geri alınacağı taban.
      this.sonKayitliStatus = this.order.status;
      this.title = this.order.order_id.toString();
      await this.siparisUrunDetay();
      await this.getOrderHash();
      
      // Start hasData check only if order is completed and not already marked as complete
      if (this.order.status === 7 && !this.processingStatus.isComplete) {
        this.startHasDataCheck();
      }
    }
  }

  async getDealerList() {
    let response = await this.$http.get(ActionsEnum.DealerMinimalize);
    this.dealers = response.data
  }

  async kuponUygula() {
    try {
      let kuponRes = await this.$http.post("/couponInsert/",
          {
            code: this.kupon,
            session_id: this.order.session_id,
            user_id: this.user.user_id
          });
      this.basket = [];
      await this.get();
      console.log("couponRes", kuponRes);
    } catch (e) {
      alert(e.message);
    }
  }

  async kuponTemizle() {
    this.kupon = "";
    try {
      let kuponRes = await this.$http.delete("/couponInsert/" + this.order.session_id);
      this.basket = [];
      await this.get();
      /*console.log("couponRes", kuponRes);*/
    } catch (e) {
      alert(e.message);
    }
  }

  async getAktarimYapilacakKisi() {
    try {
      let kisiRes = await this.$http.get(this.$store.state.panelApiUrl + "getAktarimYapilacakKisi" + "?tckimlikno=" + this.adres.tckimlikno + "&email=" + this.user.email);

      if (kisiRes.data.data.length > 0) {
        this.isYeniKullanici = false;
        this.crmKisiResponse = true;
        this.kisiler = kisiRes.data.data;
        this.kisiler = kisiRes.data.data;
        this.kisiler.forEach(user => {
          //@ts-ignore
          let sabitTelefonlar = user.Telefonlar.filter(tel => tel.Turu == 1);
          //@ts-ignore
          let cepTelefonlar = user.Telefonlar.filter(tel => tel.Turu == 2);
          if (sabitTelefonlar.length > 0)
            user.sabitTel = sabitTelefonlar[0]
          if (cepTelefonlar.length > 0)
            user.cepTel = cepTelefonlar[0]
        });
      } else {
        this.isYeniKullanici = true;
        this.crmKisiResponse = false;
      }


    } catch (e) {
      alert(e.message);
    }
  }


  // ==================== DEV-3174: SSO kimlik kapısı ====================
  // Sipariş tamamlama (durum 7) ve CRM aktarımı, tenant/lisans üretiminden
  // ÖNCE SSO kimliğini çözen ortak kapıdan geçer: onay ekranı → ssoKayit
  // (K1-K6; 409'da çakışma modalı) → CRM geri yazma → bekleyen işlem.
  // Kapı aşılamazsa satış DURUR (fail-closed): sso_id'siz üretilen job,
  // CreateTenantService'te "SSO kaydı bulunamadı" ile ölüyordu (TDT-3447).

  /**
   * Durum değişikliğini ÖNCE sunucuya yazar, SONRA zinciri başlatır.
   *
   * Select35 kendi PATCH'ini `@input`'tan sonra atıyor ve hatasını yutuyordu;
   * bu sıra eskiden zararsızdı, ama durum 7'ye artık SSO kimlik zinciri ve
   * tenant/lisans üretimi bağlı. Yazma reddedilmişken (ör. sunucu "Önce
   * siparişi onaylayınız" diyip 400 döndüğünde) zincir yine koşuyor, kullanıcı
   * "Başarılı" görüyor ve DB'de durum ilerlemiyordu — yani durumu ilerlemeyen
   * bir sipariş için tenant üretilebiliyordu.
   *
   * Yazma başarısızsa: zincir HİÇ başlamaz, `sonKayitliStatus` korunur (geri
   * alma referansı bozulmasın), seçim eski değere döner ve sunucunun gerçek
   * hatası gösterilir.
   */
  async durumDegisti(yeniDurum: any) {
    const oncekiDurum = this.sonKayitliStatus;

    try {
      await this.$http.patch("orders/" + this.order.order_id + "?status=" + yeniDurum);
    } catch (error) {
      if (oncekiDurum !== null) {
        this.order.status = oncekiDurum as any;
      }
      alert(this.durumYazmaHatasi(error));
      return;
    }

    if (yeniDurum == 7) {
      this.bekleyenIslem = "tenant";
      await this.satisOnayiniBaslat();
    } else {
      this.sonKayitliStatus = yeniDurum;
    }
  }

  /** Sunucunun kendi mesajını olduğu gibi gösterir; metin uydurmaz. */
  private durumYazmaHatasi(error: any): string {
    const yanit = error && error.response;
    const sunucu = yanit && yanit.data && yanit.data.message
        ? String(yanit.data.message).trim()
        : "";
    return "Sipariş durumu güncellenemedi"
        + (sunucu ? ": " + sunucu : (yanit ? " (HTTP " + yanit.status + ")" : " (sunucuya ulaşılamadı)"))
        + ". İşlem başlatılmadı.";
  }

  async crmAktarimiBaslat() {
    if (this.saving || this.onayHazirlaniyor) return;
    this.bekleyenIslem = "crm";
    await this.satisOnayiniBaslat();
  }

  async satisOnayiniBaslat() {
    if (this.saving) return;
    this.satisOnayDialog = true;
    await this.onayEkraniniHazirlaOrderEdit();
  }

  /**
   * Onay ekranı ön kontrolü: satışa esas kimliği (adres + CRM) çözer,
   * checksum/e-posta kilitlerini kurar, beklenen SSO dalını gösterir.
   * Buradaki dal GÖSTERMELİKTİR; bağlayıcı karar SSO matrisindedir (409).
   */
  async onayEkraniniHazirlaOrderEdit() {
    this.onayHazirlaniyor = true;
    this.onayDalKodu = null;
    this.onayKilitNedenleri = [];
    this.cakismaOnaylandi = false;
    this.secilenAdayId = null;

    const kurumMu = String(this.user.is_person) === "0";
    const eposta = ((this.adres.email || this.user.email || "") + "").trim().toLowerCase();
    const ad = kurumMu
        ? (((this.adres.company_name || "") + "").trim()
            || (((this.adres.name || "") + " " + (this.adres.lastname || "")).trim()))
        : (((this.adres.name || "") + " " + (this.adres.lastname || "")).trim());
    let kimlikNo = kurumMu ? "" : ((this.adres.tckimlikno || "") + "").trim();

    // Kurumda VKN sipariş adresinde taşınmıyor ama CRM yanıtlarında zaten
    // geliyor (kisi.VergiNo) — oradan çözülür; yalnızca gerçekten boşsa
    // aşağıdaki kilit devreye girer.
    if (kurumMu) {
      kimlikNo = await this.vknCoz(eposta);
    }

    this.onayKisi = {kurumMu: kurumMu, ad: ad, kimlikNo: kimlikNo, eposta: eposta};

    if (!ad) {
      this.onayKilitNedenleri.push(kurumMu ? "Şirket adı boş olamaz." : "Ad boş olamaz.");
    }
    if (!eposta || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(eposta)) {
      this.onayKilitNedenleri.push("E-posta boş ya da geçersiz.");
    }
    if (kimlikNo) {
      const gecerli = kurumMu ? this.vknGecerliMi(kimlikNo) : this.tcknGecerliMi(kimlikNo);
      if (!gecerli) {
        this.onayKilitNedenleri.push(kurumMu
            ? "Vergi kimlik numarası doğrulamadan (checksum) geçmiyor."
            : "TC kimlik numarası doğrulamadan (checksum) geçmiyor.");
      }
    }

    try {
      const istekler: any[] = [
        this.$http.post(this.$store.state.icwApiUrl + "admin/user-email-check", {email: eposta}),
      ];
      if (kimlikNo) {
        istekler.push(this.$http.get(this.$store.state.icwApiUrl
            + (kurumMu ? "admin/user-vkn-check/" : "admin/user-tckn-check/") + kimlikNo));
      }
      const yanitlar = await Promise.all(istekler);

      // İki ucun yanıt zarfı farklı: email-check {data:{exists,user}},
      // tckn/vkn-check {exists,user}. İkisine de dayanıklı çözümle.
      const emailVeri = yanitlar[0]?.data?.data || yanitlar[0]?.data || {};
      const epostaKaydi = emailVeri.exists ? emailVeri.user : null;
      const kimlikVeri = yanitlar[1] ? (yanitlar[1].data?.data || yanitlar[1].data || {}) : {};
      const kimlikKaydi = kimlikVeri.exists ? kimlikVeri.user : null;

      if (kimlikKaydi && epostaKaydi) {
        this.onayDalKodu = String(kimlikKaydi.id) === String(epostaKaydi.id) ? "K1" : "K5";
      } else if (kimlikKaydi) {
        this.onayDalKodu = "K2";
      } else if (epostaKaydi) {
        const kayitKimlik = String((kurumMu ? epostaKaydi.vergi_numarasi : epostaKaydi.tc_kimlik_no) || "").trim();
        if (!kimlikNo) this.onayDalKodu = "K4";
        else if (!kayitKimlik) this.onayDalKodu = "K3";
        else this.onayDalKodu = kayitKimlik === kimlikNo ? "K1" : "K2B";
      } else {
        this.onayDalKodu = "K6";
        if (!kimlikNo) {
          this.onayKilitNedenleri.push(kurumMu
              ? "Kurum müşterisinin VKN'si CRM'de bulunamadı; SSO kaydı açılamaz. Satışı Sepet Oluştur'dan geçirin."
              : "Yeni SSO kaydı için TC kimlik numarası zorunlu.");
        }
      }
    } catch (e) {
      // Ön kontrol göstermeliktir; ulaşılamazsa kilitlenmez, dal bilinmiyor
      // gösterilir. Asıl karar kayıtta (409) verilir.
      console.error("SSO ön kontrol hatası:", e);
      this.onayDalKodu = null;
    } finally {
      this.onayHazirlaniyor = false;
    }
  }

  /** Kurumun VKN'sini CRM'den çözer (kisi.VergiNo mevcut yanıtlarda geliyor). */
  async vknCoz(eposta: string): Promise<string> {
    try {
      if (this.user.musteri_no) {
        const resp: any = await this.$http.get(
            this.$store.state.panelApiUrl + "getLisansKisiMusteriNo/" + this.user.musteri_no);
        const vkn = ((resp.data && resp.data.kisi && resp.data.kisi.VergiNo) || "") + "";
        if (vkn.trim()) return vkn.trim();
      }
      const tc = ((this.adres.tckimlikno || "") + "").trim();
      if (tc && eposta) {
        const resp: any = await this.$http.get(this.$store.state.panelApiUrl
            + "getAktarimYapilacakKisi?tckimlikno=" + tc + "&email=" + eposta);
        const kisi = resp.data && resp.data.data && resp.data.data[0];
        const vkn = ((kisi && kisi.VergiNo) || "") + "";
        if (vkn.trim()) return vkn.trim();
      }
    } catch (e) {
      console.error("VKN çözümü başarısız:", e);
    }
    return "";
  }

  get onayKilitli(): boolean {
    return this.onayKilitNedenleri.length > 0 || this.onayHazirlaniyor;
  }

  async satisOnayindanVazgec() {
    this.satisOnayDialog = false;
    if (this.bekleyenIslem === "tenant") {
      await this.durumuGeriAl();
    }
    this.bekleyenIslem = null;
  }

  /** Onay ekranı "Onayla": ssoKayit → CRM geri yazma → bekleyen işlem. */
  async satisOnaylandi() {
    if (this.saving || this.onayKilitli) return;
    this.satisOnayDialog = false;
    this.saving = true;
    try {
      await this.satisZinciriniKos();
    } finally {
      this.saving = false;
    }
  }

  /** Mixin hook'u: operatör çakışmayı onayladığında zincir buradan sürer. */
  cakismaSonrasiDevam() {
    return this.satisZinciriniKos();
  }

  /** Çakışmadan vazgeç: mixin temizliği + durum-7 yolunda durumu geri al. */
  async cakismaVazgecOrderEdit() {
    this.cakismaVazgec();
    if (this.bekleyenIslem === "tenant") {
      await this.durumuGeriAl();
    }
    this.bekleyenIslem = null;
  }

  async satisZinciriniKos() {
    const licence: any = {
      user_type: this.onayKisi.kurumMu ? "company" : "person",
      first_name: this.onayKisi.kurumMu ? this.onayKisi.ad : (this.adres.name || ""),
      last_name: this.onayKisi.kurumMu ? "" : (this.adres.lastname || ""),
      sirket_adi: this.onayKisi.kurumMu ? this.onayKisi.ad : "",
      email: this.onayKisi.eposta,
      tc_kimlik_no: this.onayKisi.kurumMu ? "" : (this.onayKisi.kimlikNo || ""),
      vergi_numarasi: this.onayKisi.kurumMu ? (this.onayKisi.kimlikNo || null) : null,
      password: "yeni",
    };

    const ssoUserId = await this.ssoKayit(licence);
    if (!ssoUserId) {
      // Çakışma modalı açıldıysa karar operatörde (durum korunur, modal
      // vazgeçerse geri alınır); kesin hatada durum-7 geri çekilir.
      if (!this.ssoCakismaDialog && this.bekleyenIslem === "tenant") {
        await this.durumuGeriAl();
        this.bekleyenIslem = null;
      }
      return;
    }

    this.user.sso_user_id = String(ssoUserId);

    await this.crmSsoGeriYaz(ssoUserId, {
      email: this.onayKisi.eposta,
      tckimlikno: this.onayKisi.kurumMu ? null : this.onayKisi.kimlikNo,
      tax_number: this.onayKisi.kurumMu ? this.onayKisi.kimlikNo : null,
    });

    const islem = this.bekleyenIslem;
    this.bekleyenIslem = null;
    if (islem === "crm") {
      await this.sendDataCrm();
    } else {
      this.sonKayitliStatus = 7;
      await this.tenantJoblariniOlustur();
    }
  }

  /** Durum-7 denemesi başarısız/iptal: sunucuya yazılmış durumu geri çek. */
  async durumuGeriAl() {
    if (this.sonKayitliStatus === null) return;
    try {
      await this.$http.patch("orders/" + this.order.order_id + "?status=" + this.sonKayitliStatus);
      this.order.status = this.sonKayitliStatus as any;
    } catch (e) {
      console.error("Sipariş durumu geri alınamadı:", e);
      alert("Sipariş durumu geri alınamadı; sipariş durumunu elle kontrol edin.");
    }
  }

  /**
   * Tenant/lisans job üretimi — eski createNewTenantAndlicence gövdesi.
   * Artık YALNIZCA SSO kimlik kapısı aşıldıktan sonra çağrılır; tenant.sso_id
   * bu noktada doğrulanmış/taze user.sso_user_id'dir.
   */
  async tenantJoblariniOlustur() {
    {
      // Sipariş tamamlandığında satış işlem durumu kontrolünü başlat
      this.startHasDataCheck();

      let apiResponse: any = null;
      if (this.user.musteri_no) {
        try {
          const response = await this.$http.get(this.$store.state.panelApiUrl + `getLisansBitisTarihleri/${this.user.musteri_no}`);
          apiResponse = response.data;
          console.log("Gelen veri:", response.data);
          console.log("Müşteri No:", this.user.musteri_no);
        } catch (error) {
          console.error("Lisans bitiş tarihleri alınamadı:", error);
        }
      }
      
      this.basket.forEach((bsk: any) => {
        const job: Job = new Job();
        const tenant: Tenant = new Tenant();

        if (bsk.product_id == 7 || bsk.product_id == 8 || bsk.product_id == 10) {
          tenant.package_id = bsk.product_stock_id ? bsk.product_stock_id : 28;
          tenant.product_id = bsk.product_id ? bsk.product_id : null;
          tenant.email = this.adres.email;
          tenant.eicrapro_tc = bsk.tc_kimlik_no ? bsk.tc_kimlik_no : "";
          tenant.eicrapro_mail = bsk.eicra_eposta ? bsk.eicra_eposta : null;
          tenant.first_name = this.adres.name ? this.adres.name : this.adres.company_name;
          tenant.last_name = this.adres.name ? this.adres.lastname : "";
          tenant.office_name = this.adres.name + " " + this.adres.lastname + " BÜROSU";
          tenant.sso_id = this.user.sso_user_id ? this.user.sso_user_id : null;
          const licenseDuration = resolveLicenseDuration(bsk);
          tenant.lisans_suresi = licenseDuration.lisans_suresi;
          tenant.lisans_sure_birimi = licenseDuration.lisans_sure_birimi;
          tenant.is_demo = licenseDuration.is_demo;
          tenant.person_type = this.user.is_person;
          // tenant.satis_id = +this.order.order_id;

          job.satis_id = +this.order.order_id;
          job.args = JSON.stringify(tenant);
          
          // API'den gelen tarihleri job objesine ekle - array içinden TC'ye göre bul
          if (apiResponse && Array.isArray(apiResponse)) {
            const matchingData = apiResponse.find((item: any) => 
              item.tcKimlikNo === bsk.tc_kimlik_no
            );
            
            console.log("Basket TC:", bsk.tc_kimlik_no);
            console.log("Matching data:", matchingData);
            
            if (matchingData) {
              if (matchingData.eicraproBitisTarihi) {
                job.eicraproBitisTarihi = matchingData.eicraproBitisTarihi;
                console.log("Set eicraproBitisTarihi:", job.eicraproBitisTarihi);
              }
              if (matchingData.icraproWebBitisTarihi) {
                job.icraproWebBitisTarihi = matchingData.icraproWebBitisTarihi;
                console.log("Set icraproWebBitisTarihi:", job.icraproWebBitisTarihi);
              }
            }
          }
          
          console.log("Final job object:", job);

          try {
            this.showSuccessDialog = true;
            this.isLoading = true;
            const res = this.$http.post(this.$store.state.icwApiUrl + 'admin/job', job);
            this.isLoading = false;
            console.log(res);
            if (res) {
              this.isLoading = false;
            }
          } catch (error) {
            console.error("İstek başarısız:", error);
            this.isLoading = false;
          }
        }
      });
    }
  }

  addItem(item: any) {

    this.eslesme = true

    this.lisansKisi.ad = item.Ad;
    this.lisansKisi.soyad = item.Soyadi;
    this.lisansKisi.acik_adres = item.Adres;
    this.lisansKisi.tc_no = item.TcNo;
    this.lisansKisi.email = item.Eposta;
    this.lisansKisi.phone = item.Numara;
    this.lisansKisi.city_id = item.IlID;
    this.lisansKisi.district_id = item.IlceID;
    this.lisansKisi.vergi_dairesi = item.VergiDairesi;
    this.lisansKisi.vergi_no = item.VergiNo;
    this.lisansKisi.telefon_turu = item.TelefonTuru;


    this.$emit('input', this.lisansKisi)

  }

  async sendDataCrm() {
    if (this.basket.find(urun => urun.product_id == 1)) {
      const fromIndex = this.basket.findIndex(urun => urun.product_id == 1);
      const element = this.basket.splice(fromIndex, 1)[0];
      this.basket.splice(0, 0, element);
    }


    //burder lisans kisiyi gonder ve crm send datayı düzenle


    //sso id yi crm db ye basmak için eklendi
    if (this.user.sso_user_id) {
      this.adres.sso_user_id = String(this.user.sso_user_id);
    }


    this.crmSendData = {
      Kisi: this.adres,
      Sepet: this.basket,
      PersonelID: this.order.dealer_id ? this.order.dealer_id : 280,//v-model dan datayı al //default zirve gidiyor şu an
      BayiID: 1,
      odeme_turu: this.order.payment_type_id ? this.order.payment_type_id : 4,
      versiyon: "İCRAPRO 8.0",
      Order: this.order,
      date: this.order.created_at,
    };


    this.crmSendData.Kisi.adresler = [
      {
        adres: this.crmSendData.Kisi.adres,
        adres_type_id: this.crmSendData.Kisi.adres_type_id,
        city_id: this.crmSendData.Kisi.city_id,
        district_id: this.crmSendData.Kisi.district_id,
        post_code: "111111"
      }
    ]
    delete this.crmSendData.Kisi.adres;
    delete this.crmSendData.Kisi.adres_type_id;
    delete this.crmSendData.Kisi.city_id;
    delete this.crmSendData.Kisi.district_id;
    this.crmSendData.Kisi.baro_il_kodu = null;
    this.crmSendData.Kisi.baro_no = null;
    this.crmSendData.Kisi.tbb_no = null;
    this.crmSendData.Kisi.No = this.user.musteri_no;
    this.crmSendData.Kisi.telefonlar = [
      {
        telefon_type_id: this.crmSendData.Kisi.telefon_type_id,
        phone: this.crmSendData.Kisi.phone
      }
    ]
    delete this.crmSendData.Kisi.telefon_type_id;
    delete this.crmSendData.Kisi.phone;
    delete this.crmSendData.Kisi.user_id;

    /* console.log("crm send data -->", this.crmSendData);
     console.log("order send data -->", this.order);*/

    try {
      let kisiRes = await this.$http.post(this.$store.state.panelApiUrl + "kisiKontrol", {
        data: {Kisi: this.crmSendData.Kisi},
        sendJson: true
      })
      this.crmSendData.Kisi.user_id = kisiRes.data.data.KisiID;
      let sipRes = await this.$http.post(this.$store.state.panelApiUrl + "satisEkle", {

        data: this.crmSendData,
        sendJson: true
      })
      //console.log("MUSTERI NO-->",sipRes.data.data);
      let response = await this.$http.patch("orders/" + this.order.order_id + "?bayi_id=" + this.order.bayi_id)
      // CRM aktarımı tamamlandığında flag'i GERÇEK siparişe (order_id) kalıcı yaz. patchAction'daki
      // is_aktarildi ataması createOrder ile üretilen taslak kayda gidiyor (sipariş status=7 olduğundan
      // gerçek kayıt bulunamıyor); bu yüzden updateFields üzerinden doğrudan bu siparişe işliyoruz.
      // Böylece sayfa yenilense/ekran yeniden açılsa da "CRM'e Aktar" butonu pasif kalır.
      await this.$http.patch("orders/" + this.order.order_id + "?is_aktarildi=1")
      this.order.is_aktarildi = 1;


      alert(`Sipariş Kayedildi.. MÜŞTERİ NUMARASI :${sipRes.data.Musteri.MusteriNo}    Lisans Numarası :${sipRes.data.Musteri.No}`);
      await this.$http.patch("orders/" + this.order.order_id + "?musteri_no=" + sipRes.data.Musteri.MusteriNo);
      await this.$http.patch("orders/" + this.order.order_id + "?lisans_no=" + sipRes.data.Musteri.No);
      await this.get();
    } catch (e) {
      alert(this.$helper.errorHandler(e));
    }
  }

  getDealerName() {
    this.dealer = this.dealers.find((d: any) => d.id == this.order.dealer_id);
    if (this.dealer) {
      return this.dealer.name + " " + this.dealer.lastname;
    }
  }

  isUpgradeonChange(item: any) {
    //@ts-ignore
    this.basket.find(urun => urun.product_id == item.UrunId).is_upgrade = item.is_upgrade;
  }


  async sendSms() {
    let response = await this.$http.post("sendOrderLinkSms/" + this.order.order_id, {
      phone: this.adres.mobil_tel,
    });
    alert(response.data.message);
  }

  async sendMail() {
    let response = await this.$http.post("sendOrderLinkMail/" + this.order.order_id, {
      email: this.user.email
    });
    alert(response.data.message);
  }

  async createOrderHash() {
    let response = await this.$http.post("createOrderHash", {
      order_id: this.order.order_id,
      user_id: this.user.user_id,
      session_id: this.order.session_id
    });
    this.orderHash = response.data;
  }

  async getOrderHash() {
    let response = await this.$http.get("createOrderHash/" + this.order.order_id);
    if (typeof response.data.url != "undefined")
      this.orderHash = response.data;
  }

  async createOrderOldDate() {
    try {
      let response = await this.$http.get("createOrderOldDate/");
      this.isAuthCreateOldDate = true;
    } catch (e) {

    }
  }

  async siparisUrunDetay() {
    let toplamIndirimliFiyat: number = 0;
    let toplamIndirimsizFiyat: number = 0;
    let toplamKdv: number = 0;
    //KDV' yi orderdan aldım toplam gelsin diye
    //@ts-ignore
    toplamKdv = parseFloat(this.order.kdv);


    for (let bskt of this.basket) {
      let indirimsizFiyat: number = 0;
      let indirimlifiyat: number = 0;

      let AylikYillik: any = 0;
      let YeniAlinanUrununSeviyesi: any = 0;
      let YeniAlinanUrununProgramIdsi: any = 0;

      if (bskt.product_id == 7) { //İcraProWeb
        YeniAlinanUrununSeviyesi = bskt.product_stock.level
        YeniAlinanUrununProgramIdsi = bskt.product_id
        AylikYillik = bskt.price_type_id
      }

      let ProgramUrunData = {
        UserId: 40, //this.adres.user_id,
        SessionId: this.adres.session_id,
        Seviyesi: YeniAlinanUrununSeviyesi,
        ProgramId: YeniAlinanUrununProgramIdsi,
        AyYil: AylikYillik,
        date: this.order.created_at,
      };
      //@ts-ignore
      if (!bskt.product_stock_id) { //tekli ürünler
        indirimsizFiyat += parseFloat(bskt.price);
        indirimlifiyat += parseFloat(bskt.piece_price);
      } else {
        if (bskt.price_type_id == 1) {//AYLIK
          if (bskt.product_stock.ex_price > bskt.product_stock.price) {
            indirimsizFiyat = parseFloat(bskt.product_stock.ex_price);
            indirimlifiyat = parseFloat(bskt.product_stock.price);
          } else {
            indirimlifiyat = parseFloat(bskt.product_stock.price);
            indirimsizFiyat = parseFloat(bskt.product_stock.price);
          }
        } else {//YILLIK
          if (bskt.product_stock.ex_price_year > bskt.product_stock.price_year) {
            indirimsizFiyat = parseFloat(bskt.product_stock.ex_price_year);
            indirimlifiyat = parseFloat(bskt.product_stock.price_year);
          } else {
            indirimlifiyat = parseFloat(bskt.product_stock.price_year);
            indirimsizFiyat = parseFloat(bskt.product_stock.price_year);
          }
        }
      }


      toplamIndirimliFiyat += indirimlifiyat;
      toplamIndirimsizFiyat += indirimsizFiyat;

      let visible = false;
      try {
        let response = await this.$http.post(this.$store.state.panelApiUrl + "yukseltmeKontrol", {
          data: ProgramUrunData,
          sendJson: true
        });
        console.log("yukseltme kontrol", response);
        visible = response.data ? true : false;
        console.log(visible)
      } catch (e) {
        console.log(e);
      }


      //console.log("BASKET-" + bskt.basket_id, bskt);

      let urunData = {
        'BasketId': bskt.basket_id,
        'Urun': bskt.product.name,
        'UrunId': bskt.product_id,
        'PaketSure': bskt.price_type_id,
        'Secenek': bskt.product_option.name,
        'Adet': bskt.piece,
        'IndirimliFiyat': indirimlifiyat * bskt.piece,
        'IndirimsizFiyat': indirimsizFiyat * bskt.piece,
        'is_visible': visible,
        'eicra_eposta': bskt.eicra_eposta ? bskt.eicra_eposta : "",
        'tc_kimlik_no': bskt.tc_kimlik_no ? bskt.tc_kimlik_no : null,
        'rumuz': bskt.Rumuz ? bskt.Rumuz : ""
      };
      this.urunTabloData.push(urunData);
    }
    let toplamData = {
      'ToplamFiyat': toplamIndirimliFiyat,
      'ToplamIndirimsizFiyat': toplamIndirimsizFiyat,
      'ToplamKdv': toplamKdv,
    }
    this.urunTabloToplamData = toplamData;

  }

  tutarStr(val: number): string {
    // let temp = new Intl.NumberFormat('tr-TR', {style: 'currency', currency: 'TRY'}).format(val);
    if (!val) {
      val = 0.00;
    }
    return new Intl.NumberFormat('tr-TR', {minimumFractionDigits: 2}).format(val) + " " + " TL";

  }

  async deleteBasketItem(basket_id: number) {
    let ask = confirm("Sepete eklenen ürün silinecek onaylıyormusun ?");
    if (ask) {
      await this.$http.delete("basket/" + basket_id);
      await this.get();
    }
  }

  getFromCities(country_id: number) {
    if (!country_id) {
      return [];
    }
    return this.cities.filter(x => x.country_id == country_id)
  }

  getFromDistricts(city_id: number) {
    return this.districts.filter(x => x.city_id == city_id)
  }

  getDealer(dealerId: any) {
    let dealer: any = this.dealers.find((x: any) => x.id == dealerId);
    if (dealer) {
      return dealer.name + " " + dealer.lastname;
    }
    return "(ONLINE SATIN ALIM)";
  }

  getTableHeaders() {
    const baseHeaders = [
      { text: 'Ürün', value: 'Urun', sortable: false, width: '25%' },
      { text: 'Seçenek', value: 'Secenek', sortable: false, width: '15%' },
      { text: 'Paket', value: 'PaketSure', sortable: false, width: '8%' },
      { text: 'Adet', value: 'Adet', sortable: false, align: 'center', width: '6%' }
    ];

    const eicraHeaders = this.urunTabloData.some(item => item.tc_kimlik_no || item.eicra_eposta) ? [
      { text: 'TC', value: 'tc_kimlik_no', sortable: false, width: '12%' },
      { text: 'E-posta', value: 'eicra_eposta', sortable: false, width: '15%' },
      { text: 'rumuz', value: 'rumuz', sortable: false, width: '10%' }
    ] : [];

    const remainingHeaders = [
      { text: 'İndirimli', value: 'IndirimliFiyat', sortable: false, align: 'right', width: '10%' },
      { text: 'Liste', value: 'IndirimsizFiyat', sortable: false, align: 'right', width: '10%' },
      { text: 'Yükselt', value: 'is_upgrade', sortable: false, align: 'center', width: '8%' },
      { text: 'Sil', value: 'actions', sortable: false, align: 'center', width: '5%' }
    ];

    return [...baseHeaders, ...eicraHeaders, ...remainingHeaders];
  }

  // hasData check methods
  async startHasDataCheck() {
    // Do not start if the process is already marked as complete
    if (this.processingStatus.isComplete) return;
    
    // Do not start if already checking
    if (this.hasDataCheckInterval) return;

    this.stopHasDataCheck(); // Clear any existing intervals
    this.processingStatus.showProgress = true;
    this.processingStatus.isChecking = true;
    this.processingStatus.isComplete = false; // Reset completion state
    this.processingStatus.checksCount = 0; // Reset counter
    this.processingStatus.errorCount = 0; // Reset error counter
    this.processingStatus.networkError = false; // Reset network error flag
    
    // Start interval to check every 2 seconds
    this.hasDataCheckInterval = setInterval(() => {
      this.checkHasData();
    }, 2000);
    
    // Perform first check immediately
    this.checkHasData();
  }

  async checkHasData() {
    // Stop if max checks reached
    if (this.processingStatus.checksCount >= this.processingStatus.maxChecks) {
      console.error('İşlem zaman aşımına uğradı, kontrol durduruluyor.');
      this.stopHasDataCheck();
      this.processingStatus.showProgress = false;
      if (this.$toast) {
        this.$toast.error('İşlem çok uzun sürdü ve zaman aşımına uğradı.');
      }
      return;
    }

    // Stop if already complete
    if (this.processingStatus.isComplete) {
      this.stopHasDataCheck();
      return;
    }

    try {
      this.processingStatus.isChecking = true;
      this.processingStatus.checksCount++; // Increment counter

      const response = await this.$http.get(this.$store.state.icwApiUrl + `admin/satis-request-check/${this.order.order_id}`);
      const data = response.data;
      
      // Handle undefined values from API
      const hasData = data.hasData === true;
      const count = typeof data.count === 'number' ? data.count : 0;
      
      this.processingStatus.hasData = hasData;
      this.processingStatus.count = count;
      this.processingStatus.networkError = false;
      this.processingStatus.errorCount = 0;
      
      // Stop if API returns undefined values (means API is not working properly)
      if (data.hasData === undefined && data.count === undefined) {
        this.processingStatus.isComplete = true;
        this.stopHasDataCheck();
        this.showProcessingSuccess();
        return;
      }
      
      // Stop if count equals or exceeds basketLength (all jobs processed)
      if (count >= this.basket.length) {
        this.processingStatus.isComplete = true;
        this.stopHasDataCheck();
        this.showProcessingSuccess();
        return;
      }
      
      // Force stop after max checks
      if (this.processingStatus.checksCount >= this.processingStatus.maxChecks) {
        this.processingStatus.isComplete = true;
        this.stopHasDataCheck();
        this.processingStatus.showProgress = false;
        return;
      }

      // Safeguard: Stop if the count is illogical
      if (data.count > this.basket.length * 2) {
        console.warn('İşlem sayısı bekleneni aştı, kontrol durduruluyor.', {
          count: data.count,
          basketLength: this.basket.length
        });
        this.stopHasDataCheck();
        this.processingStatus.showProgress = false;
        if (this.$toast) {
          this.$toast.warning('İşlemde beklenmedik bir durum oluştu.');
        }
        return;
      }
      
    } catch (error) {
      console.error('Satış işlem kontrolü başarısız:', error);
      this.processingStatus.networkError = true;
      this.processingStatus.errorCount++;
      
      // Stop after too many consecutive errors
      if (this.processingStatus.errorCount >= 5) {
        console.error('Çok fazla hata, kontrol durduruluyor.');
        this.stopHasDataCheck();
        this.processingStatus.showProgress = false;
        if (this.$toast) {
          this.$toast.error('Çok fazla hata nedeniyle işlem durumu kontrol edilemedi.');
        }
        return;
      }
      
      // Stop for critical server errors (500+)
      if (error?.response?.status >= 500) {
        console.error('Sunucu hatası, kontrol durduruluyor.');
        this.stopHasDataCheck();
        this.processingStatus.showProgress = false;
        if (this.$toast) {
          this.$toast.error('Sunucu hatası nedeniyle işlem durumu kontrol edilemedi.');
        }
        return;
      }
      
    } finally {
      this.processingStatus.isChecking = false;
    }
  }

  stopHasDataCheck() {
    if (this.hasDataCheckInterval) {
      clearInterval(this.hasDataCheckInterval);
      this.hasDataCheckInterval = null;
    }
    this.processingStatus.isChecking = false;
  }

  showProcessingSuccess() {
    this.processingStatus.showProgress = false;
    if (this.$toast) {
      this.$toast.success('Tüm satış işlemleri başarıyla tamamlandı!');
    }
  }

  // UI Helper methods for sales processing
  getCountColor() {
    if (!this.processingStatus.hasData && this.processingStatus.count >= this.basket.length) {
      return 'success';
    } else if (this.processingStatus.count > this.basket.length) {
      return 'warning';
    }
    return 'info';
  }

  getProgressColor() {
    const percentage = this.getProgressPercentage();
    if (percentage === 100) return 'success';
    if (percentage > 50) return 'warning';
    return 'info';
  }

  getProgressPercentage() {
    if (this.basket.length === 0) return 0;
    return Math.min((this.processingStatus.count / this.basket.length) * 100, 100);
  }

  beforeDestroy() {
    this.stopHasDataCheck();
  }

  async mounted() {
    await this.get();
    await this.getDealerList();
    await this.createOrderOldDate();
    this.paymentTypes = await this.$store.dispatch("getPaymentTypes");
    this.cities = await this.$store.dispatch("getCities");
    this.districts = await this.$store.dispatch("getDistricts");
    await this.$store.dispatch("getOrderStatus");
  }
}

